<div
    [ngClass]="{
        'image-profile': isPlayer || (participantImage?.isParticipantProfile && showBackgroundCircle),
        'player-shirt': !isPlayer && (!participantImage?.isParticipantProfile || !showBackgroundCircle),
        'fallback-color': fallbackColor,
    }"
    [class.rotate-image]="rotateImage && image?.type !== imageType.Logo"
    [class.image-loaded]="loaded && image?.type !== imageType.Fallback"
    [style.background-color]="backgroundColor">
    @if (image) {
        <img
            disableOptimizedSrcset
            ngSrcset="1x, 2x, 3x"
            [width]="32"
            [height]="32"
            [ngSrc]="image.url"
            [class]="imageClass"
            (error)="onImageFailedLoaded()" />
    }
</div>
